<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2022-12-09 16:55:02
 * @LastEditors: 聂章帅
 * @LastEditTime: 2023-09-06 11:08:21
-->
<template>
  <div class="root">
    <h3>{{ detail.projectname }}</h3>
    <div class="father">
      <h4>项目详情</h4>
      <div class="child">
        <p>
          项目编号：
          <span>{{ detail.numbering }}</span>
        </p>

        <p>
          项目名称：
          <span>{{ detail.projectname }}</span>
        </p>
        <p>
          资金来源：
          <span>{{ detail.moneysource }}</span>
        </p>
        <p>
          项目坐落：
          <span>{{ detail.address }}</span>
        </p>
        <p>
          项目工期：
          <span>{{ detail.timelimit }}</span>
        </p>
        <p>
          招标文件领取开始时间：
          <span>{{ detail.getstarttime }}</span>
        </p>

        <p>
          招标文件领取结束时间：
          <span>{{ detail.getstoptime }}</span>
        </p>

        <p>
          招标文件价格：
          <span>{{ detail.price }} 元</span>
        </p>
        <p>
          保证金：
          <span>{{ detail.deposit }} 元</span>
        </p>
        <p>
          投标人要求：
          <span>{{ detail.condition }}</span>
        </p>
        <p>
          招标人姓名：
          <span>{{ detail.tendername }}</span>
        </p>
        <p>
          招标人联系方式：
          <span>{{ detail.tenderphone }}</span>
        </p>
        <p>
          招标内容：
          <span>{{ detail.tendercontent }}</span>
        </p>
        <p>
          采购代理机构联系人：
          <span>{{ detail.linkman }}</span>
        </p>
        <p>
          采购代理机构：
          <span>{{ detail.agentname }}</span>
        </p>
        <p>
          采购代理机构联系电话：
          <span>{{ detail.linkphone }}</span>
        </p>
      </div>
    </div>

    <div class="demo-image__preview">
      <el-image
        v-for="(item, index) in srcList.length <= 6
          ? srcList
          : srcList.slice(0, 6)"
        :key="index"
        style="width: 200px; height: 200px; margin-right: 10px"
        :src="item"
        :preview-src-list="srcList"
        fit="cover">
      </el-image>
    </div>

    <div class="father">
      <h4>报名须知</h4>
      <div class="child2">
        <p>一、报名人持下列材料到本县农村产权交易服务中心报名：</p>
        <p>1、有效资格证件：</p>
        <p class="hui">
          （1）
          意向受让方为自然人，需提供本人身份证复印件或常住人口户口簿复印件；
        </p>
        <p class="hui">
          （2） 意向受让方为公司，需提供
          法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、公司章程以及董事会或股东（大）会同意受让决议；
        </p>
        <p class="hui">
          （3）
          意向受让方为合作社，需提供法定代表人身份证复印件、已年检的营业执照、开户行资信证明、开户行许可证、已年检组织机构代码证、已年检税务登记证、开发项目的可行性报告书、合作社成员同意受让决议。
        </p>
        <p>2、若为授权人提出申请，需提供授权委托书及身份证复印件。</p>
        <p>
          二、挂牌期满，若征集到符合条件的意向受让方，采取协议或者竞标方式确定受让方。
        </p>
        <p>三、法定节假日、公休日不受理报名。</p>
        <p class="cheng"></p>
      </div>
    </div>

    <div class="button">
      <!-- <a href="javascript:;">
          <img src="../assets/img/文件下载.png" alt />
        </a> -->
      <a href="javascript:;" v-show="keys" @click="toChanquanbaoming">
        <img src="../assets/img/立即报名.png" alt />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},

      srcList: [],
      // 项目状态
      keys: true,
      id: '',
      number: '001',
    }
  },
  created() {
    // console.log(this.$route.query.id);
    let id = this.$route.query.id
    let number = this.$route.query.number
    this.id = id
    this.keys = this.$route.query.keys == '报名中' ? true : false
    let url = 'jiaoyixiangmuxiangqing'
    console.log(this.ajax_data(url, { id, number }).data)
    // this.detail = this.ajax_id(url, id).data;
    this.detail = this.ajax_data(url, { id, number }).data
    // console.log(this.detail);

    let imgArr = this.detail.addressimg ? this.detail.addressimg : []
    // console.log(imgArr);
    for (let i = 0; i < imgArr.length; i++) {
      const element = imgArr[i]

      this.srcList[i] = this.requestUrl1 + element
    }
    // console.log(this.srcList);
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    toChanquanbaoming() {
      this.$router.push({ name: '产权报名', query: { id: this.id } })
    },
  },
}
</script>

<style scoped>
.root {
  min-height: 1180px;
  display: block;
  margin: 0 auto;
  margin-bottom: 35px;
  padding: 0 260px;
  width: 1340px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}

.root > h3 {
  margin: 0 auto;
  padding: 50px 0 57px 0;
  width: 1200px;
  height: 26px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  color: #333333;
  letter-spacing: 5px;
  overflow: hidden;
}

.father {
  display: block;
  padding-bottom: 50px;
  width: 1340px;
  height: auto;
  overflow: hidden;
}

.father > h4 {
  display: block;
  padding-left: 10px;
  margin-bottom: 30px;
  border-left: 6px solid #2187ff;
  width: auto;
  height: 29px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 29px;
  color: #333333;
}

.child {
  width: 1340px;
  height: 346px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: space-between;
}

.child p {
  display: block;
  width: 670px;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #999999;
  overflow: hidden;
}

.child p span {
  color: #666666;
}

.child1 {
  width: 1340px;
  height: 163px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: space-between;
}

.child1 p {
  display: block;
  width: 100%;
  height: 18px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 18px;
  color: #999999;
  overflow: hidden;
}

.child1 p span {
  color: #666666;
}

.child2 {
  width: 1340px;
  height: auto;
  display: block;
}

.child2 p {
  height: auto;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #666666;
}

.child2 .hui {
  color: #999999;
}

.child2 .cheng {
  color: #f96226;
}

.button {
  margin: 0 auto;
  margin-bottom: 90px;
  width: 460px;
  height: 50px;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.button a {
  display: block;
  width: 180px;
  height: 50px;
}

.button a img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
